
import "./Avatar.scss";
import defaultAvatar from "../../../img/default_user.png";

const Avatar = (props) => {
  const size = props.size ? props.size : "big";
  const cls = props.className ? props.className : "";
  const image = props.image ? props.image : defaultAvatar;
  const isOnline = props.isOnline ? props.isOnline : false;

  return (
    <picture className={`Avatar Avatar_size_${size} ${cls}`}>
      <img className="Avatar__image" src={image} />
      {isOnline && (
        <svg className="Avatar__status-icon" viewBox="0 0 31 31" fill="#5B82FF" xmlns="http://www.w3.org/2000/svg">
          <path d="m12 31 1-9-8 5-4-7 8-4-8-4 4-7 8 5-1-9h8l-1 9 8-5 4 7-8 4 8 4-4 7-8-5 1 9h-8Z" />
        </svg>
      )}
    </picture>
  );
};

export default Avatar;
